import { Record } from 'immutable';

import prefix from 'OPENTOK/prefix';

export const PUBLISHER_STATUS_INIT = prefix('PUBLISHER_STATUS_INIT');
export const PUBLISHER_STATUS_CONNECTING = prefix('PUBLISHER_STATUS_CONNECTING');
export const PUBLISHER_STATUS_CONNECTED = prefix('PUBLISHER_STATUS_CONNECTED');

const PublisherRecord = Record({
  id: null,
  sessionId: null,
  streamId: null,
  object: null,
  status: PUBLISHER_STATUS_INIT,
  videoElement: null,
  videoStatus: null,
  audioStatus: null,
  videoType: null,
  name: null,
  sourceType: 'publisher',
  audioLevel: 0,
});

export default class Publisher extends PublisherRecord {
  isPublished() {
    return this.get('status') !== PUBLISHER_STATUS_INIT;
  }

  isConnected() {
    return this.get('status') === PUBLISHER_STATUS_CONNECTED && this.get('videoElement');
  }

  updateAudioLevel(value) {
    let result;
    if (this.audioLevel === null || this.audioLevel <= value) {
      result = value;
    } else {
      result = (0.7 * this.audioLevel) + (0.3 * value);
    }

    return this.set('audioLevel', result);
  }
}
